import { useEffect, useMemo } from 'react';
import { AdvanceFilter } from '../../types/filter.types';
import { useFiltersContext } from '../useFiltersContext';

export const useAdvanceFilters = (advanceFiltersList: AdvanceFilter<string[]>[]) => {
  const { onRegister, filters } = useFiltersContext();

  useEffect(() => {
    advanceFiltersList.forEach(({ path, isMultiple }) => {
      onRegister({ path, value: isMultiple ? [] : undefined, isMultiple: !!isMultiple });
    });
  }, [advanceFiltersList, onRegister]);

  const isApplied = useMemo(
    () =>
      advanceFiltersList.some((advFilter) => {
        const filterValue = filters[advFilter.path]?.value;
        if (filterValue) {
          if (Array.isArray(filterValue)) {
            return filterValue.length > 0;
          }
          if (typeof filterValue === 'object') {
            return Object.values(filterValue).some(Boolean);
          }
          return filterValue;
        }
        return typeof filterValue === 'boolean' ? true : filterValue;
      }),
    [advanceFiltersList, filters],
  );

  return { isApplied };
};
